/**
 * admin module
 */
export default {
  'views/admin/deviceList': () => import('@/views/admin/deviceList/index.vue'),
};
